<template>
  <svg
    width="512"
    height="269"
    viewBox="0 0 512 269"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1303_20)">
      <path d="M0 0.298828H512V33.8965H0V0.298828Z" fill="#CC0000" />
      <path d="M0 33.8965H512V67.4023H0V33.8965Z" fill="white" />
      <path d="M0 67.4023H512V101H0V67.4023Z" fill="#CC0000" />
      <path d="M0 101H512V134.598H0V101Z" fill="white" />
      <path d="M0 134.598H512V168.012H0V134.598Z" fill="#CC0000" />
      <path d="M0 168.104H512V201.701H0V168.104Z" fill="white" />
      <path d="M0 201.701H512V235.299H0V201.701Z" fill="#CC0000" />
      <path d="M0 235.299H512V268.896H0V235.299Z" fill="white" />
      <path d="M0 0.0234375H256V168.012H0V0.0234375Z" fill="#000066" />
      <path
        d="M157.269 49.233L161.029 70.4431L175.441 52.6919L167.608 73.1189L189.932 62.2854L172.308 77.9482L198 76.2514L173.953 84.0176L198 91.6532L172.308 90.0217L189.932 105.685L167.687 94.7858L175.363 115.343L160.95 97.5268L157.19 118.737L153.509 97.5268L139.096 115.278L146.851 94.7858L124.606 105.685L142.151 90.0217L116.459 91.6532L140.506 83.9523L116.538 76.1862L142.23 77.883L124.606 62.2201L146.851 73.0536L139.018 52.5614L153.509 70.3779L157.269 49.1025V49.233ZM136.355 50.0814C126.116 46.3127 114.55 45.8919 103.956 48.9027C93.3616 51.9135 84.5151 58.1354 79.1746 66.3316C75.6441 71.7671 73.7977 77.8508 73.8028 84.0311C73.8079 90.2115 75.6644 96.2931 79.2039 101.724C82.7434 107.156 87.854 111.765 94.0724 115.135C100.291 118.505 107.42 120.528 114.814 121.021C122.189 121.504 129.592 120.45 136.355 117.954C128.864 122.432 120.035 125.102 110.841 125.671C101.646 126.239 92.4415 124.684 84.239 121.176C76.0366 117.668 69.154 112.344 64.3483 105.788C59.5427 99.2323 57 91.6993 57 84.0176C57 76.3358 59.5427 68.8028 64.3483 62.2471C69.154 55.6913 76.0366 50.3668 84.239 46.859C92.4415 43.3512 101.646 41.796 110.841 42.3646C120.035 42.9331 128.864 45.6033 136.355 50.0814Z"
        fill="#FFCC00"
      />
    </g>
    <defs>
      <clipPath id="clip0_1303_20">
        <rect width="512" height="269" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
